import { useEffect, useState } from "react";
import { FaHeart } from "react-icons/fa";
import { FiHeart, FiMaximize2, FiX } from "react-icons/fi";

import LazyImage from "../components/ui/LazyImage";

// Dynamically load every illustration (kept from the original portfolio).
const ctx = require.context("../assets/illustrations", false, /\.png$/);
const images = ctx.keys().map((key) => ({
  src: ctx(key),
  name: key
    .replace(/^\.\//, "")
    .replace(/\.png$/i, "")
    .replace(/[-_]+/g, " "),
}));

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);
  const [likes, setLikes] = useState(() => {
    const init = {};
    images.forEach((img) => {
      if (localStorage.getItem(`like-${img.src}`) === "true") init[img.src] = true;
    });
    return init;
  });

  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => e.key === "Escape" && setLightbox(null);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [lightbox]);

  const toggleLike = (src) =>
    setLikes((prev) => {
      const next = { ...prev, [src]: !prev[src] };
      localStorage.setItem(`like-${src}`, String(!!next[src]));
      return next;
    });

  return (
    <div className="page gallery-page">
      <div className="page-head">
        <h1 className="page-title">
          Gallery <span className="page-title-alt">/ Illustrations</span>
        </h1>
        <span className="page-sub">
          {images.length} illustrations & creative experiments
        </span>
      </div>

      <div className="gallery-grid">
        {images.map((img) => (
          <figure key={img.src} className="gallery-card">
            <button
              type="button"
              className="gallery-img"
              onClick={() => setLightbox(img)}
              aria-label={`Open ${img.name}`}
            >
              <LazyImage src={img.src} alt={img.name} />
            </button>
            <figcaption className="gallery-foot">
              <button
                type="button"
                className={`gallery-like${likes[img.src] ? " is-liked" : ""}`}
                onClick={() => toggleLike(img.src)}
                aria-label="Like"
              >
                {likes[img.src] ? <FaHeart /> : <FiHeart />}
              </button>
              <button
                type="button"
                className="gallery-expand"
                onClick={() => setLightbox(img)}
                aria-label="Expand"
              >
                <FiMaximize2 />
              </button>
            </figcaption>
          </figure>
        ))}
      </div>

      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button
            type="button"
            className="lightbox-close icon-btn"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <FiX />
          </button>
          <LazyImage
            src={lightbox.src}
            alt={lightbox.name}
            eager
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
